export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20still%20life%20collage%20composition%20featuring%20meticulously%20arranged%20fashion%20items%20including%20white%20leather%20sneakers%20a%20cashmere%20sweater%20folded%20neatly%20designer%20sunglasses%20a%20structured%20handbag%20and%20minimalist%20watch%20all%20laid%20out%20on%20textured%20rice%20paper%20surface%20with%20soft%20directional%20morning%20light%20creating%20gentle%20overlapping%20shadows%20warm%20earthy%20neutral%20palette%20with%20hints%20of%20olive%20and%20terracotta%20sophisticated%20editorial%20aesthetic&width=1920&height=1080&seq=pandabuy-hero-main-v3&orientation=landscape"
          alt="Pandabuy Spreadsheet product collage"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center pt-20">
        {/* Main Headline */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tight max-w-4xl">
          BEST PANDABUY
          <br />
          SPREADSHEET
          <br />
          DATABASE 2026
        </h1>

        {/* Subheadline */}
        <p className="mt-6 md:mt-8 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
          Discover the most complete Pandabuy Spreadsheet index with daily updated product finds,
          price comparisons, and curated lists for sneakers, streetwear, and luxury items.
        </p>

        {/* Trust microcopy */}
        <p className="mt-4 text-xs md:text-sm text-white/60 tracking-wide">
          Updated daily &middot; Community curated &middot; 1000+ items indexed
        </p>

        {/* CTA Buttons */}
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold whitespace-nowrap rounded-md bg-white text-foreground-900 hover:bg-background-100 transition-all duration-200 cursor-pointer shadow-lg shadow-black/10"
          >
            Explore Spreadsheet Database
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold whitespace-nowrap rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer shadow-lg shadow-black/10"
          >
            View Trending Finds
          </a>
        </div>

        {/* Value Prop Blocks */}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 max-w-4xl w-full">
          <div className="text-left">
            <p className="text-sm md:text-base text-white/80 leading-relaxed">
              <strong className="text-white font-semibold">Why Pandabuy Spreadsheet?</strong> A structured, searchable
              database of curated product listings sourced from top-performing spreadsheets
              across the community. Instantly access verified lists organized by quality,
              price, and popularity.
            </p>
          </div>
          <div className="text-left md:pt-4">
            <p className="text-sm md:text-base text-white/80 leading-relaxed">
              <strong className="text-white font-semibold">14 Categories available.</strong> From sneakers and
              streetwear to luxury accessories and fragrances. Browse the complete
              Pandabuy Spreadsheet index and find exactly what you are looking for
              in seconds, not hours.
            </p>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="mt-16 md:mt-20 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-xs text-white/50 tracking-widest uppercase">Scroll to explore</span>
          <i className="ri-arrow-down-s-line text-white/50 text-lg"></i>
        </div>
      </div>
    </section>
  );
}